import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNominaActivaComboBox } from "../../../../redux/actions/nomina";
import { getSectores, removeTrabajadores } from "../../../../redux/actions/resolucion";
import TrabajadoresFormContainer from "./TrabajadoresFormContainer";
import TrabajadoresSectorTable from "./TrabajadoresSectorTable";

const TrabajadoresSectorContainer = ({ handleCancelResolucion, nextForm }) => {
  const dispatch = useDispatch();
  const data = useSelector(
    (state) => state.resolucion.postResolucion.trabajadores
  );
  const nomina = useSelector((state) => state.nomina.nominaActivaCombo.data);
  const sectores = useSelector((state) => state.resolucion.sectores.data);
  const [editingRow, setEditingRow] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const idDependenciaEmpleador = useSelector(
    (state) => state.resolucion.searchedEstablecimiento
  );
  useEffect(() => {
    if (sectores.length === 0) {
      dispatch(getSectores(idDependenciaEmpleador));
    }
    if (nomina.length === 0) {
      dispatch(getNominaActivaComboBox());
    }
  }, []);

  const handleOpenFormularioTrabajador = (row) => {
    setEditingRow(row);
    setShowForm(true);
  };

  const handleDelete = (rows) => {
    dispatch(removeTrabajadores(rows));
  };

  return (
    <div>
      {showForm ? (
        <TrabajadoresFormContainer
          editingRow={editingRow}
          setShowForm={setShowForm}
        />
      ) : (
        <TrabajadoresSectorTable
          data={data}
          handleOpenFormularioTrabajador={handleOpenFormularioTrabajador}
          handleDelete={handleDelete}
          handleCancelResolucion={handleCancelResolucion}
          handleNext={() => nextForm("ContratistasYEmpresas")}
        />
      )}
    </div>
  );
};

export default TrabajadoresSectorContainer;
